import { ContributionStatusEnum } from '../api/users/interfaces/ContributionData';

// Valores en minúscula: son las claves de STATUS_CONFIG en AdminContribucionesV2
export enum AdminContributionStatusEnum {
	CONFIRMED = 'confirmed',
	PENDING = 'pending'
}

// El estado sale de los datos, no de la fecha (Arca-Team/product#44: antes el mes en curso salía
// «Pendiente» todo el mes aunque ya estuviera confirmado). Lista blanca: solo CONFIRMED se enseña
// como confirmado, para que un ERROR nunca lo parezca si el back llega a mandarlo.
export const resolveAdminMovementStatus = (
	status?: ContributionStatusEnum
): AdminContributionStatusEnum =>
	status === ContributionStatusEnum.CONFIRMED
		? AdminContributionStatusEnum.CONFIRMED
		: AdminContributionStatusEnum.PENDING;

// Pendiente si algún movimiento lo está, o si es el mes en curso (o futuro) y aún no ha llegado
// nada: ni movimientos ni importe en los totales del back (que ya vienen agrupados por mes)
export const resolveAdminMonthStatus = (
	movementStatuses: AdminContributionStatusEnum[],
	isCurrentOrFuture: boolean,
	hasActivity: boolean
): AdminContributionStatusEnum =>
	movementStatuses.includes(AdminContributionStatusEnum.PENDING) ||
	(isCurrentOrFuture && movementStatuses.length === 0 && !hasActivity)
		? AdminContributionStatusEnum.PENDING
		: AdminContributionStatusEnum.CONFIRMED;

// month en base 1
export const isCurrentOrFutureMonth = (year: number, month: number, now = new Date()): boolean =>
	year === now.getFullYear() && month >= now.getMonth() + 1;
